import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
// import "animate.css"; 
import React, { useEffect } from "react";
import { FaTools } from "react-icons/fa"; // Import a maintenance icon

function Others() {
    useEffect(() => {
        AOS.init({
            duration: 2000,
            once: true,
        });
    }, []);

    return (
        <>
            {/* Page Header */}
            <div className="container-fluid page-header py-5 mb-5 animate__animated animate__fadeIn">
                <div className="container py-5">
                    <h1 className="display-3 text-white animate__animated animate__slideInRight">
                    Others
                    </h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb animate__animated animate__slideInRight mb-0">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/">Products</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                            Others
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            {/* Under Construction Message */}
            <div className="container d-flex justify-content-center">
                <div
                    className="card text-center p-4 shadow-lg animate__animated animate__zoomIn"
                    style={{ maxWidth: "500px", backgroundColor: "#f8d7da", marginBottom: "7%" }}
                >
                    <FaTools size={50} color="#721c24" className="mb-3" />
                    <h3 className="text-danger">Under Construction</h3>
                    <p className="text-dark mb-0">
                        We are currently working on this section. Stay tuned for updates!
                    </p>
                </div>
            </div>
        </>
    );
}

export default Others;
